export default __webpack_public_path__ + "static/media/daet-favorite.ac2c4fb0.png";